import React, { useEffect } from "react";
import { Modal, Form, Input, InputNumber, message } from "antd";
import api from "../api";

const EditEgresoModal = ({ open, record, onCancel, onSuccess }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open && record) {
      form.setFieldsValue({
        calibre: record.calibre,
        kgCaja: record.kgCaja,
        cajas: record.cajas,
      });
    } else {
      form.resetFields();
    }
  }, [open, record, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await api.put(`/egresos/modificar/${record.idegresos}`, values);
      message.success("Egreso modificado exitosamente");
      form.resetFields();
      onSuccess();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Error al modificar el egreso");
      }
    }
  };

  return (
    <Modal
      title="Editar Egreso"
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Guardar"
      cancelText="Cancelar"
    >
      <Form form={form} layout="vertical">
        <Form.Item name="calibre" label="Calibre" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="kgCaja" label="Kg por Caja" rules={[{ required: true }]}>
          <InputNumber style={{ width: "100%" }} disabled />
        </Form.Item>
        <Form.Item name="cajas" label="Cajas" rules={[{ required: true }]}>
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditEgresoModal;
